import dynamic from "next/dynamic";
const HubspotDynamicFormIframeComponent = dynamic(()=>import("./hubspot-dynamic-form-iframe-component"));
import HubspotDynamicFormIframeConfig from "./hubspot-dynamic-form-iframe-config";
import HubspotDynamicFormIframeAdvancedConfig from "./hubspot-dynamic-form-iframe-advanced-config";
export default {
    HubspotDynamicFormIframeComponent,
    HubspotDynamicFormIframeConfig,
    HubspotDynamicFormIframeAdvancedConfig
};
